document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.uu-size[data-variant-id]');
  if (!btn) return;
  e.preventDefault();
  if (btn.disabled || btn.classList.contains('is-busy')) return;
  btn.classList.add('is-busy');
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    });
    if (!res.ok) throw new Error(await res.text());
    uuToast((btn.dataset.product || 'Item') + ' \u00b7 ' + (btn.dataset.size || btn.textContent.trim()) + ' added to bag');
    document.dispatchEvent(new CustomEvent('uu:cart-updated'));
    uuRefreshCartCount();
  } catch (err) {
    uuToast('Could not add that size. Please try again.');
    console.error('[uu] add to cart failed', err);
  } finally {
    setTimeout(() => btn.classList.remove('is-busy'), 400);
  }
});

function uuToast(msg) {
  let el = document.querySelector('.uu-toast');
  if (!el) {
    el = document.createElement('div');
    el.className = 'uu-toast';
    el.innerHTML = '<span></span><a href="/cart">View bag</a>';
    document.body.appendChild(el);
  }
  el.querySelector('span').textContent = msg;
  el.classList.add('is-open');
  clearTimeout(uuToast._t);
  uuToast._t = setTimeout(() => el.classList.remove('is-open'), 3000);
}

async function uuRefreshCartCount() {
  try {
    const cart = await (await fetch('/cart.js')).json();
    document.querySelectorAll('[data-uu-cart-count], .cart-count-bubble span:first-child')
      .forEach(n => { n.textContent = cart.item_count; });
  } catch (e) {}
}
